import Input from 'components/Input/Input';
import InstructionBox from 'components/Instruction/InstructionBox';
import { InstructionCallout } from 'components/Instruction/InstructionCallout';
import InstructionItem from 'components/Instruction/InstructionItem';
import { AppLink } from 'components/Link/AppLink';
import COLORS from 'constants/colors';
import { useAutoScrollInstructions } from 'hooks/useAutoScrollInstructions';
import styled from 'styled-components';
import MainContainer from '../../SignInMainContainer';

interface WebserviceProps {
  clientCode: {
    value: string;
    invalid: boolean;
    onChange: (value: string, invalid?: boolean) => void;
  };
  fullDomain: {
    value: string;
    invalid: boolean;
    onChange: (value: string, invalid?: boolean) => void;
  };
  instructionsLink?: string;
  instructionsInnerHtmlToScroll?: string;
}

const StyledInstructionBox = styled(InstructionBox)`
  margin-bottom: 12px;
`;

const Webservice = ({
  clientCode,
  fullDomain,
  instructionsLink,
  instructionsInnerHtmlToScroll,
}: WebserviceProps) => {
  useAutoScrollInstructions(instructionsLink, instructionsInnerHtmlToScroll);

  return (
    <>
      {instructionsLink && (
        <>
          <InstructionCallout
            link={instructionsLink}
            innerHtmlToScroll={instructionsInnerHtmlToScroll}
          >
            Open{' '}
            <AppLink
              href={instructionsLink}
              rel="noreferrer"
              target="_blank"
              showInFrame
              innerHtmlToScroll={instructionsInnerHtmlToScroll}
            >
              this guide
            </AppLink>{' '}
            to find the required values. Then paste them below and click Continue.
          </InstructionCallout>
          <StyledInstructionBox>
            <InstructionItem index={1} badgeColor={COLORS.GRAY.GRAY_600}>
              Navigate to Company Setup
            </InstructionItem>
            <InstructionItem index={2} badgeColor={COLORS.GRAY.GRAY_600}>
              Find and paste the required values below
            </InstructionItem>
          </StyledInstructionBox>
        </>
      )}
      <MainContainer useNewDesign>
        <Input
          value={fullDomain.value}
          onChange={(event) => fullDomain.onChange(event.target.value)}
          invalid={fullDomain.invalid}
          label="Web Service URL"
          id="fullDomain"
          helperText="Example: secure.saashr.com"
        />
        <Input
          value={clientCode.value}
          onChange={(event) => clientCode.onChange(event.target.value)}
          invalid={clientCode.invalid}
          label="Company Short Name"
          id="clientCode"
        />
      </MainContainer>
    </>
  );
};

export default Webservice;
